import React from "react";

// Progressive-disclosure classification cascade for the normal add flow, on the
// new segment APIs. Each step renders only after the previous is chosen — this
// ordering is deliberate (the PDF filename derives from these picks).
// onMetadataChange fires on every select change (not the radio, matching
// legacy) so an already-uploaded PDF gets invalidated.
const ClassificationCascade = ({ catalog, onMetadataChange }) => {
    return (
        <React.Fragment>
            <div className="olp-field">
                <div className="olp-radio-group">
                    {catalog.classTypes.map((classType) => (
                        <label key={classType.ClassTypeId}>
                            <input
                                type="radio"
                                name="ClassType"
                                value={classType.ClassTypeId}
                                checked={catalog.selectedClassTypeId === classType.ClassTypeId}
                                onChange={() => catalog.selectClassType(classType.ClassTypeId)}
                            />
                            {classType.label}
                        </label>
                    ))}
                </div>
            </div>
            {catalog.selectedClassTypeId && (
                <div className="olp-field">
                    <label htmlFor="ExamCategoryoptions">Lütfen sınav türünü seçiniz: </label>
                    <select
                        className="olp-select"
                        id="ExamCategoryoptions"
                        value={catalog.selectedSegmentId}
                        onChange={(e) => {
                            onMetadataChange();
                            catalog.selectSegment(e.target.value);
                        }}
                    >
                        <option value="">Sınav türünü seçiniz</option>
                        {catalog.segmentOptions.map((segment) => (
                            <option key={segment.Id} value={segment.Id}>
                                {segment.Id === 3 ? segment.ClassTypeName : segment.ExamTypeName}
                            </option>
                        ))}
                    </select>
                </div>
            )}
            {catalog.selectedSegmentId && (
                <div className="olp-field">
                    <label htmlFor="Courseoptions">Lütfen ders seçiniz: </label>
                    <select
                        className="olp-select"
                        id="Courseoptions"
                        value={catalog.selectedCourseId}
                        onChange={(e) => {
                            onMetadataChange();
                            catalog.selectCourse(e.target.value);
                        }}
                    >
                        <option value="">Ders Seçiniz:</option>
                        {catalog.courses.map((course) => (
                            <option key={course.Id} value={course.Id}>
                                {course.Name}
                            </option>
                        ))}
                    </select>
                </div>
            )}
            {catalog.selectedCourseId && (
                <div className="olp-field">
                    <label htmlFor="SubCourseOptions">Lütfen Konu seçiniz: </label>
                    <select
                        className="olp-select"
                        id="SubCourseOptions"
                        value={catalog.selectedTitle}
                        onChange={(e) => {
                            onMetadataChange();
                            catalog.selectTitle(e.target.value);
                        }}
                    >
                        <option value="">Konu Seçiniz:</option>
                        {catalog.titleOptions.map((title) => (
                            <option key={title} value={title}>
                                {title}
                            </option>
                        ))}
                    </select>
                </div>
            )}
            {catalog.selectedTitle && (
                <div className="olp-field">
                    <label htmlFor="SubCourseTopicsOptions">Lütfen konu Alt Başlığı Seçiniz: </label>
                    <select
                        className="olp-select"
                        id="SubCourseTopicsOptions"
                        value={catalog.selectedTopicId}
                        onChange={(e) => {
                            onMetadataChange();
                            catalog.selectTopic(e.target.value);
                        }}
                    >
                        <option value="">Konu Alt başlığı Seçiniz: </option>
                        {catalog.subTopicOptions.map((topic) => (
                            <option key={topic.Id} value={topic.Id}>
                                {topic.Name}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </React.Fragment>
    );
};

export default ClassificationCascade;
